export interface ActionHeaderConfig {
    actionText?: string;
    filterText?: string;
    searchText?: string;
    hasBackButton?: boolean;
}
